import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NotificationListComponent } from './notification-list.component';
import { DateAdapter, MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSortModule, MatTableModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { PristineSharedModule } from '@pristinebase/shared.module';



const routes: Routes=[
    {
        path:'vendor_notification_create/notification_list',
        component:NotificationListComponent
    }
]

@NgModule({
  declarations: [NotificationListComponent],
  imports: [
    CommonModule,
     RouterModule.forChild(routes),
     MatPaginatorModule,
      MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    PristineSharedModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatListModule,
    MatRippleModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
  ],
  providers:[DatePipe]
})
export class NotificationListModule { }
